<div class="scrollable">
  <div class="row">
    <div class="field">
      <h2>{{statusMessage}}</h2>
    </div>
  </div>
  @for (file of allFilesUploadStatus; track file.uniqueID) {
    <div class="row" style="min-width: 350px">
      <div class="field">
        <soho-card [expandableHeader]="true" [verticalButtonAction]="true" [autoHeight]="true">
          <soho-card-header>
            <p class="heading" style="width:80%">{{file.fileName}}, {{file.fileSize}} MB<br/><span class="sub-heading" style="color: #0072ED;font-weight: bold;">{{file.status.toString()}}</span></p>
            <button soho-button="icon" icon="more" soho-context-menu menu="action-popupmenu" trigger="click"
                class="btn-actions"></button>
            <ul soho-popupmenu id="action-popupmenu">
              <li soho-popupmenu-item><a soho-popupmenu-label>TODO</a></li>
            </ul>
          </soho-card-header>
          <soho-card-pane class="card-pane">
            <div id="data-list" class="listview tableview">
              <ul class="card-content-list">
                @for (part of file.allPartsStatus; track part.partNumber) {
                  <li class="card-list-item alternate">
                    <p class="micro-text" style="width:90%">{{'Part' | translate}} {{part.partNumber}} <span style="float: right;color: #0072ED;font-weight: bold;">{{part.status.toString()}}</span></p>
                  </li>
                }
              </ul>
            </div>
          </soho-card-pane>
        </soho-card>
      </div>
    </div>
  }
</div>
